module.exports = __webpack_public_path__ + "img/screen_second.530a728d.png";